import React, { useState } from "react";
import Icon from "./icons";

/**
 * Password field with a reveal toggle — the eye in the mockups.
 *
 * Starts masked and never unmasks itself, so an editor left open on a shared
 * screen does not sit there showing a database password.
 */
export default function SecretInput({ value, onChange, placeholder, className = "rsce-input" }) {
  const [revealed, setRevealed] = useState(false);

  return (
    <span className="rsce-secret">
      <input
        className={className}
        type={revealed ? "text" : "password"}
        placeholder={placeholder}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        autoComplete="new-password"
      />
      <button
        type="button"
        className="rsce-secret-toggle"
        title={revealed ? "Hide" : "Show"}
        aria-label={revealed ? "Hide value" : "Show value"}
        onClick={() => setRevealed((r) => !r)}
      >
        {revealed ? Icon.eyeOff : Icon.eye}
      </button>
    </span>
  );
}
